import * as React from 'react'
import './errorBoundary.css'

interface State {
    hasError: boolean
}

interface Props {

}

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
    }

    render() {
        if (this.state.hasError) {
            return <div className={'error-boundary-wrapper'}>
                <div className={'error-boundary-container'}>
                    <div>
                        <i style={{fontSize: 80}} className="far fa-frown" />
                    </div>
                    <h1 className={'error-boundary-heading'}>
                        Ooops! Something went wrong.
                    </h1>
                    <h5 className={'error-boundary-heading'}>
                        This page didn't load the content correctly. Check the JavaScript console for technical details.
                    </h5>
                </div>
            </div>
        }
        return this.props.children;
    }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./app/components/common/ErrorBoundary/ErrorBoundary.tsx